import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { getComponentNdeStatus } from '@dis/models';

@Component({
  selector: 'nde-dates',
  templateUrl: './nde-dates.component.html',
  styleUrls: ['./nde-dates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    DatePipe,
    MatChipsModule,
  ]
})
export class NdeDatesComponent {
  // Only needs lastNdeDate/lastNdeInspection, so it works for both legacy Component instances and
  // a raw Data Connect row (whose JSON-scalar fields are optional, not just nullable) without
  // either being mapped into the other.
  component = input.required<{ lastNdeDate?: Date | string | null; lastNdeInspection?: Date | string | null }>({
    alias: 'item',
  });

  protected $nde = computed(() => getComponentNdeStatus(this.component().lastNdeInspection ?? this.component().lastNdeDate));
}
